import React, { memo } from "react";

import { validators, formats } from "investira.sdk";
import {
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  Icon,
  Typography,
  IconButton,
  Stack,
  useMediaQuery,
  Card,
  Tooltip,
  Box,
} from "investira.react.components";
import DetalhesAtivos from "./DetalhesAtivos";
import CorrelacaoCenarioTooltip from "./CorrelacaoCenarioTooltip";
import CorrelacaoCenario from "./CorrelacaoCenario";

const DetalhesDialog = memo((props) => {
  const { infos, ativos, correlacoes, benchmarks, onSetAtivos } = props;

  const isUpMd = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const xDialogProps = isUpMd
    ? {
        fullScreen: true,
        maxWidth: "xl",
      }
    : {
        fullScreen: true,
        PaperProps: {
          sx: {
            margin: 0,
          },
        },
      };

  const isOpen = !validators.isEmpty(ativos);

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Dialog
        fullScreen
        open={isOpen}
        onClose={() => onSetAtivos({})}
        {...xDialogProps}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Stack gap={2} flexGrow={1} direction="row">
              <Typography variant="h6">
                {infos.cenario.cenario} - {infos.mercado}{" "}
                {infos.periodo && `| ${infos.periodo}`}
              </Typography>
              {infos.variacoes && (
                <Tooltip
                  title={
                    <CorrelacaoCenarioTooltip variacoes={infos.variacoes} />
                  }
                  arrow={true}
                >
                  <IconButton color="primary" size="small">
                    <Icon iconName="chart_lines" size={21} />
                  </IconButton>
                </Tooltip>
              )}
            </Stack>
            <IconButton
              edge="end"
              color="primary"
              onClick={() => onSetAtivos({})}
              aria-label="close"
            >
              <Icon iconName="cancel" size={21} />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ display: "flex", px: 3 }}>
          <Stack flexGrow={1} mt={2} sx={{ width: "100%" }}>
            <Stack
              sx={{ gap: 2 }}
              component="section"
              direction={{ xs: "column", md: "row" }}
              mb={2}
            >
              {/* {infos.maior_correlacao && (
                <Card
                  variant="outlined"
                  sx={{
                    display: "flex",
                    flexGrow: 1,
                  }}
                >
                  <Stack
                    px={2}
                    py={2}
                    flexGrow={1}
                    justifyContent="space-between"
                  >
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontWeight: 500 }}
                    >
                      Maior Correlação
                    </Typography>
                    <Stack direction="column" justifyContent="flex-end">
                      <Stack>
                        <Typography variant="h5" color={"textPrimary"}>
                          <b>{infos.maior_correlacao}</b>
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Card>
              )} */}

              <Card
                variant="outlined"
                sx={{
                  display: "flex",
                  flexGrow: 1,
                }}
              >
                <Stack
                  px={2}
                  py={2}
                  flexGrow={1}
                  justifyContent="space-between"
                >
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontWeight: 500 }}
                  >
                    Impacto Total (%)
                  </Typography>
                  <Stack direction="column" justifyContent="flex-end">
                    <Stack>
                      <Typography variant="h5" color={"textPrimary"}>
                        <b>
                          {infos.impacto_percentual_total &&
                            formats.formatNumber(
                              infos.impacto_percentual_total,
                              2,
                              true
                            )}
                        </b>
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Card>

              <Card
                variant="outlined"
                sx={{
                  display: "flex",
                  flexGrow: 1,
                }}
              >
                <Stack
                  px={2}
                  py={2}
                  flexGrow={1}
                  justifyContent="space-between"
                >
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontWeight: 500 }}
                  >
                    Impacto Total (R$)
                  </Typography>
                  <Stack direction="column" justifyContent="flex-end">
                    <Stack>
                      <Typography variant="h5" color={"textPrimary"}>
                        <b>
                          {infos.impacto_financeiro_total &&
                            formats.formatNumber(
                              infos.impacto_financeiro_total,
                              2,
                              true
                            )}
                        </b>
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Card>
            </Stack>
            {/* <Box component="section" mb={2}>
              <CorrelacaoCenario variacoes={infos.variacoes} />
            </Box> */}
            <DetalhesAtivos
              ativos={ativos}
              correlacoes={correlacoes}
              benchmarks={benchmarks}
              cenarioId={infos.cenario.cenario_id}
              variacoes={infos.variacoes}
            />
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
});

export default DetalhesDialog;
